import authReducer from './auth.reducer'
import budgetReducer from './budget.reducer'
import catalogsReducer from './catalogs.reducer'
import collectionsReducer from './collections.reducer'
import errorReducer from './error.reducer'
import i18nReducer from './i18n.reducer'
import orderReducer from './order.reducer'
import productsReducer from './products.reducer'
import ordersReducer from './orders.reducer'
import projectReducer from './project.reducer'
import projectsReducer from './projects.reducer'
import registrationReducer from './registration.reducer'
import resourcesReducer from './resources.reducer'
import supportReducer from './support.reducer'
import uiReducer from './ui.reducer'
import geoReducer from './geo.reducer'
import formValuesReducer from './formValues.reducer'
import socketReducer from './socket.reducer'

export default {
	standardReducers: {
		authReducer,
		budgetReducer,
		catalogsReducer,
		collectionsReducer,
		formValuesReducer,
		errorReducer,
		geoReducer,
		i18nReducer,
		orderReducer,
		ordersReducer,
		productsReducer,
		projectReducer,
		projectsReducer,
		registrationReducer,
		resourcesReducer,
		socketReducer,
		supportReducer
	},
	persistedReducers: {
		uiReducer
	}
}
